import {lazyLoad} from 'app/components/ads/lazyLoadHelpers';

const eagerLoadedAdSlotIds = ['ad-Skyscraper', 'ad-Skyscraper_2', 'ad-Sticky_Mobile_Banner'];

const loadAdSlot = (slotId: string, loadFunc: () => void, isDesktop: boolean) => {
  if (eagerLoadedAdSlotIds.includes(slotId)) {
    loadFunc();
    return;
  }

  // use setTimeout to execute lazyLoad after scrollY has been restored on back navigation
  setTimeout(() => lazyLoad(slotId, loadFunc, isDesktop), 0);
};

export default loadAdSlot;
